const $ = window.jQuery;

import Cally from "cally";
import FileUploader from '../components/_file-uploader.js';

/**
 * Fix du datepicker ACF dans les <dialog> DaisyUI.
 *
 * Problème : jQuery UI crée #ui-datepicker-div dans <body> lors de la première
 * initialisation. La <dialog> (showModal) est dans le top-layer du navigateur,
 * donc tout élément hors top-layer est masqué derrière son overlay, peu importe
 * le z-index — changer appendTo après init ne déplace pas le div déjà créé.
 *
 * Solution : dans beforeShow, déplacer manuellement #ui-datepicker-div dans la
 * <dialog> (top-layer) de façon synchrone avant que jQuery UI l'affiche, puis
 * appliquer position:fixed avec les coordonnées viewport en setTimeout pour
 * contourner overflow:clip sur .modal.
 */
(function registerDatePickerFix() {
    const applyFix = function ($input) {
        const $dialog = $input.closest('dialog');
        if (!$dialog.length) return;
        try {
            $input.datepicker('option', {
                beforeShow: function (input) {
                    // Déplacement synchrone dans le top-layer avant l'affichage
                    const $dp = $('#ui-datepicker-div');
                    if ($dp.length && !$.contains($dialog[0], $dp[0])) {
                        $dialog.append($dp);
                    }
                    // Repositionnement après que jQuery UI ait calculé sa position
                    setTimeout(function () {
                        const $dp2 = $('#ui-datepicker-div');
                        if (!$dp2.length) return;
                        const rect = input.getBoundingClientRect();
                        $dp2.css({
                            position: 'fixed',
                            top:      Math.round(rect.bottom) + 'px',
                            left:     Math.round(rect.left)   + 'px',
                            bottom:   'auto',
                            right:    'auto',
                            zIndex:   9999,
                        });
                    }, 0);
                },
            });
        } catch (e) {}
    };

    if (typeof acf !== 'undefined') {
        acf.addAction('date_picker_init', function ($input) {
            applyFix($input);
        });
    } else {
        // Fallback : ACF pas encore évalué au moment du chargement du module
        $(function () {
            if (typeof acf !== 'undefined') {
                acf.addAction('date_picker_init', function ($input) {
                    applyFix($input);
                });
            }
        });
    }
}());

/**
 * Initialise FileUploader sur tous les formulaires ACF du document
 */
function initFileUploaders() {
    document.querySelectorAll('.acf-form:not([data-uploader-init])').forEach(form => {
        new FileUploader(form);
        form.dataset.uploaderInit = 'true';
    });
}

// Init au chargement de la page (formulaire de création)
initFileUploaders();

const frontPage = {
    readyFn: function () {
        let self = this;
        self.initSelect2InModals();
        self.initEditPrestation();
        self.initCopyPrestation();
        self.initDeletePrestation();
        self.filterPrestations();
        self.resetFilters();
        self.searchPrestations();
        self.initWeekSwitcher();
        self.initCompactView();
        initFileUploaders();
    },

    // Force Select2 à s'attacher à la modale pour hériter du bon z-index
    initSelect2InModals: function () {
        if (typeof acf === 'undefined') return;

        acf.add_filter('select2_args', function (args, $select, settings, field, instance) {
            const $modal = $select.closest('#edit_prestation, #create_prestation, #copy_prestation');
            if ($modal.length) {
                args.dropdownParent = $modal;
            }
            return args;
        });
    },

    initEditPrestation: function () {
        const modalContent = document.querySelector('#edit_prestation .ajax-content');
        const ajaxUrl = window.modData?.ajaxUrl ?? '';

        document.querySelectorAll('.js-edit-prestation').forEach(btn => {
            btn.addEventListener('click', function () {
                const prestationId = this.dataset.prestationId;
                modalContent.innerHTML = '<p class="text-center p-8">Chargement...</p>';

                fetch(`${ajaxUrl}?action=load_prestation_form&prestation_id=${prestationId}`)
                    .then(response => response.text())
                    .then(html => {
                        modalContent.innerHTML = html;
                        if (window.acf) {
                            window.acf.do_action('append', $(modalContent));
                        }
                        initFileUploaders();
                    });
            });
        });
    },

    initCopyPrestation: function () {
        const modal        = document.querySelector('#copy_prestation');
        const modalContent = modal.querySelector('.ajax-content');
        const ajaxUrl      = window.modData?.ajaxUrl ?? '';
        let currentDraftId   = null;
        let currentDiscardNonce = null;

        document.querySelectorAll('.js-copy-prestation').forEach(btn => {
            btn.addEventListener('click', function () {
                const prestationId = this.dataset.prestationId;
                modalContent.innerHTML = '<p class="text-center p-8">Chargement...</p>';
                currentDraftId = null;
                currentDiscardNonce = null;

                fetch(`${ajaxUrl}?action=load_copy_prestation_form&prestation_id=${prestationId}`)
                    .then(response => response.text())
                    .then(html => {
                        modalContent.innerHTML = html;
                        const wrapper = modalContent.querySelector('[data-post-id]');
                        if (wrapper) {
                            currentDraftId      = wrapper.dataset.postId;
                            currentDiscardNonce = wrapper.dataset.discardNonce;
                        }
                        if (window.acf) {
                            window.acf.do_action('append', $(modalContent));
                        }
                        initFileUploaders();
                    });
            });
        });

        // Si l'utilisateur ferme la modale sans valider → supprimer le brouillon
        modal.addEventListener('close', function () {
            if (!currentDraftId || !currentDiscardNonce) return;

            const formData = new FormData();
            formData.append('action', 'discard_prestation_draft');
            formData.append('post_id', currentDraftId);
            formData.append('nonce', currentDiscardNonce);

            fetch(ajaxUrl, { method: 'POST', body: formData });

            currentDraftId = null;
            currentDiscardNonce = null;
            modalContent.innerHTML = '';
        });
    },

    initDeletePrestation: function () {
        const modal      = document.querySelector('#delete_prestation');
        const titleEl    = modal.querySelector('.js-delete-prestation-title');
        const confirmBtn = modal.querySelector('.js-delete-prestation-confirm');
        const ajaxUrl    = window.modData?.ajaxUrl ?? '';
        const nonce      = window.modData?.deleteNonce ?? '';
        let currentId    = null;

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.js-delete-prestation');
            if (!btn) return;
            e.preventDefault();
            currentId        = btn.dataset.prestationId;
            titleEl.textContent = btn.dataset.prestationTitle;
            modal.showModal();
        });

        confirmBtn.addEventListener('click', function () {
            if (!currentId) return;

            const formData = new FormData();
            formData.append('action', 'delete_prestation');
            formData.append('post_id', currentId);
            formData.append('nonce', nonce);

            fetch(ajaxUrl, { method: 'POST', body: formData })
                .then(r => r.json())
                .then(data => {
                    if (!data.success) {
                        alert(data.data ?? 'Erreur lors de la suppression.');
                        return;
                    }
                    // Supprimer la carte du DOM
                    const card = document.getElementById('prestation-' + currentId);
                    if (card) {
                        card.remove();
                    }
                    modal.close();
                    currentId = null;
                });
        });
    },

    filterPrestations: function () {
        let self = this;

        // Gestion des filtres au clic
        $(document).on('click', '.filter-item', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            self.applyFilters();
        });
    },

    applyFilters: function () {
        var filters = [];
        $('.filter-item.active').each(function () {
            var val = $(this).attr('data-filter');
            if (val) filters.push(val);
        });

        var searchTerm = $('input[name=search]').val().toLowerCase().trim();
        var $items = $('.prestation-item');

        $items.each(function () {
            var $item = $(this);
            var matchesFilter = filters.length === 0 || filters.some(f => $item.is(f));
            var matchesSearch = searchTerm === '' || $item.text().toLowerCase().includes(searchTerm);

            if (matchesFilter && matchesSearch) {
                $item.stop(true, true).slideDown(300).animate(
                    { opacity: 1 },
                    { queue: false, duration: 300 }
                );
            } else {
                $item.stop(true, true).slideUp(300).animate(
                    { opacity: 0 },
                    { queue: false, duration: 300 }
                );
            }
        });
    },

    searchPrestations: function () {
        let self = this;
        $(document).on('keyup', 'input[name=search]', function () {
            self.applyFilters();
        });
    },

    initWeekSwitcher: function () {
        const prevBtn        = document.getElementById('prev-week');
        const nextBtn        = document.getElementById('next-week');
        const currentWeekEl  = document.getElementById('current-week');
        const switcher       = document.getElementById('week-switcher');

        // Uniquement en mode ancre (week_support = false)
        if (!prevBtn || !prevBtn.classList.contains('to-anchor')) return;

        /**
         * Retourne le lundi et le dimanche d'une semaine ISO (year + week).
         */
        function getISOWeekDates(year, week) {
            // Le 4 janvier est toujours dans la semaine 1 ISO
            const jan4      = new Date(year, 0, 4);
            const dayOfWeek = (jan4.getDay() + 6) % 7; // 0 = lundi
            const monday1   = new Date(jan4);
            monday1.setDate(jan4.getDate() - dayOfWeek);
            const monday = new Date(monday1);
            monday.setDate(monday1.getDate() + (week - 1) * 7);
            const sunday = new Date(monday);
            sunday.setDate(monday.getDate() + 6);
            return { start: monday, end: sunday };
        }

        function pad2(n) { return String(n).padStart(2, '0'); }
        function fmtDate(d) { return pad2(d.getDate()) + '/' + pad2(d.getMonth() + 1); }

        function getYearForWeek(week) {
            const header = document.getElementById('week-' + pad2(week));
            if (header && header.dataset.year) return parseInt(header.dataset.year, 10);
            return parseInt(switcher.dataset.year || new Date().getFullYear(), 10);
        }

        function updateSwitcher(week, year) {
            const { start, end } = getISOWeekDates(year, week);
            currentWeekEl.innerHTML =
                '<span class="font-semibold">S' + pad2(week) + '</span>'
                + ' - ' + fmtDate(start) + ' > ' + fmtDate(end);
            prevBtn.href = '#week-' + pad2(week - 1);
            nextBtn.href = '#week-' + pad2(week + 1);
        }

        [prevBtn, nextBtn].forEach(btn => {
            btn.addEventListener('click', function () {
                const hash = this.getAttribute('href').replace('#', '');
                const week = parseInt(hash.replace('week-', ''), 10);
                if (isNaN(week) || week < 1 || week > 53) return;
                updateSwitcher(week, getYearForWeek(week));
            });
        });
    },

    initCompactView: function () {
        const toggle = document.getElementById('toggle-compact-view');
        if (!toggle) return;

        // Restaurer l'état depuis localStorage
        const saved = localStorage.getItem('compactView') === '1';
        toggle.checked = saved;
        document.body.classList.toggle('compact-view', saved);

        toggle.addEventListener('change', function () {
            document.body.classList.toggle('compact-view', this.checked);
            localStorage.setItem('compactView', this.checked ? '1' : '0');
        });
    },

    resetFilters: function () {
        let self = this;

        $(document).on('click', '.reset-filters', function (e) {
            e.preventDefault();

            // Désélectionner tous les filtres de cette modale
            $(this).closest('dialog').find('.filter-item').removeClass('active');

            // Réappliquer les filtres restants (des autres modales)
            self.applyFilters();

            // Fermer la modale
            $(this).closest('dialog')[0].close();
        });
    }

};

export { frontPage };